import React from "react";
import { Link } from "react-router-dom";
import { Disclaimer } from "./Disclaimer";

const CONTACT_EMAIL = "contacto@procure.justsapiens.com";
// WhatsApp para piloto: cambiar al número definitivo al lanzar.
const WHATSAPP_NUMBER = "573000000000"; // formato internacional sin "+"
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hola, vengo desde JustSapiens Procure y tengo una consulta sobre el piloto."
);

export function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-gray-200 bg-gradient-to-b from-white to-[#FAF8EE]">
      <div className="container-prose py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img
                src="/brand/logo-horizontal-positive.png"
                alt="JustSapiens Procure"
                className="h-11 w-auto object-contain"
                loading="lazy"
                decoding="async"
              />
            </div>
            <p className="text-sm text-gray-600 max-w-xs leading-relaxed">
              Diagnóstico precontractual con IA y revisión humana experta para compras públicas en Colombia.
            </p>
            <p className="mt-4 text-xs text-brand-burgundy-light italic font-serif">
              &ldquo;La justicia y el derecho más cerca.&rdquo;
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-3 font-semibold">Producto</h4>
            <ul className="space-y-2 text-sm text-gray-700">
              <li><Link to="/" className="hover:text-brand-burgundy transition-colors">Niveles</Link></li>
              <li><Link to="/register" className="hover:text-brand-burgundy transition-colors">Crear cuenta</Link></li>
              <li><Link to="/login" className="hover:text-brand-burgundy transition-colors">Iniciar sesión</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-3 font-semibold">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-700">
              <li>
                <Link to="/normativa-aplicable" data-testid="footer-normativa-link" className="hover:text-brand-burgundy transition-colors">
                  Normativa aplicable
                </Link>
              </li>
              <li>
                <Link to="/terminos" data-testid="footer-terms-link" className="hover:text-brand-burgundy transition-colors">
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link to="/politica-datos" data-testid="footer-data-policy-link" className="hover:text-brand-burgundy transition-colors">
                  Política de tratamiento de datos
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 mb-3 font-semibold">Contacto</h4>
            <ul className="space-y-2 text-sm text-gray-700">
              <li>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="footer-contact-email"
                  className="hover:text-brand-burgundy transition-colors break-all"
                >
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-brand-burgundy transition-colors inline-flex items-center gap-1.5"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.6.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.4-.7-2.3-1.3-3.2-2.8-.2-.4.2-.4.6-1.2.1-.1 0-.3 0-.4 0-.1-.6-1.5-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.3.3-1 .9-1 2.3 0 1.4 1 2.7 1.2 2.9.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.2-.2-.3-.4-.4zM12 0C5.4 0 0 5.4 0 12c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.6c1.7 1 3.6 1.5 5.7 1.5 6.6 0 12-5.4 12-12S18.6 0 12 0zm0 22c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-3.7.9.9-3.7-.2-.4c-1-1.6-1.5-3.5-1.5-5.4C1.8 6.5 6.4 1.9 12 1.9S22.2 6.5 22.2 12 17.6 22 12 22z" />
                  </svg>
                  WhatsApp
                </a>
              </li>
              <li className="text-xs text-gray-500 mt-2">
                Lun–Vie · 9:00 a 17:00 (COT)
              </li>
            </ul>
          </div>
        </div>

        <Disclaimer compact dataTestId="footer-disclaimer" />

        <div className="mt-6 pt-6 border-t border-gray-200 flex flex-col sm:flex-row justify-between gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} JustSapiens. Procure es un producto de JustSapiens. Todos los derechos reservados.</span>
          <span>Hecho en Colombia · Ley 1581 de 2012</span>
        </div>
      </div>
    </footer>
  );
}
